import React from "react";
import { Modal, ModalBody } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Assets/responsive.css";

import { useVendor } from "../Store/VendorStore";

const FollowEventsModal = ({ isOpen, toggle }) => {
  const { vendorData } = useVendor();
  return (
    <>
      {/* Modal */}
      <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
        <div className="modal-header d-flex justify-content-between align-items-center">
          <h3 className="modal-title">{vendorData?.Name || "Vendor"}</h3>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={toggle}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "2rem",
              cursor: "pointer",
              position: "absolute",
              top: "9px",
              right: "20px",
            }}
          >
            &times;
          </button>
        </div>
        <ModalBody>
          <p>
            <b> Plan Your Perfect Weekend</b> <br/>  Discover vendor markets,
            food pop-ups, and local events all around you. See what’s happening,
            save your favorites, and make every weekend unforgettable.
          </p>
          <div className="d-flex justify-content-evenly">
            <a
              href="https://play.google.com/store/apps/details?id=com.mycompany.tacos"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/Images/Playstore.png"
                alt="Play Store"
                style={{ width: "150px", height: "auto" }}
              />
            </a>
            <a
              href="https://apps.apple.com/pk/app/wknd-app/id6736915994"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/Images/appstore.png"
                alt="App Store"
                style={{ width: "150px", height: "auto", marginTop: "13px" }}
              />
            </a>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default FollowEventsModal;
